"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../_abstract/adapter");
const _contracts_1 = require("../_contracts");
const adapter_2 = require("../_helpers/adapter");
const smartypants_1 = __importDefault(require("../../vendors/smartypants"));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class ParagraphAdapter extends adapter_1.AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `ParagraphModule` to the `ParagraphToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        this.validate(object, {
            content: {
                presence: true
            },
            'content.text': {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        const { text } = object.content;
        return {
            content: text,
            raw: this.decodeHtml(text),
            type: demarked_1.TokenType.Paragraph
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `ParagraphToken` to the `ParagraphModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        const { content: text } = token;
        return {
            ...adapter_2.getModuleBase(),
            content: { text: smartypants_1.default(text, '1') },
            driver: _contracts_1.ModuleDriver.Paragraph
        };
    }
    decodeHtml(html) {
        if (typeof document === 'undefined') {
            return html;
        }
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }
}
exports.ParagraphAdapter = ParagraphAdapter;
//# sourceMappingURL=Paragraph.adapter.js.map